export const ProductionDeclarationStatusCode = {
  Pending: 'pending',
  Submitted: 'submitted',
  Approved: 'approved',
};

export type ProductionDeclarationStatusCode =
  (typeof ProductionDeclarationStatusCode)[keyof typeof ProductionDeclarationStatusCode];
